import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loading } from '../utils';
import { useAppContext } from '../../contexts/Storage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, token } = useAppContext();
  const [isCheckingAuth, setIsCheckingAuth] = React.useState(true);

  React.useEffect(() => {
    // Check if auth data is loaded
    // token might be null initially while loading from cookies
    setIsCheckingAuth(false);
  }, [user, token]);

  if (isCheckingAuth) {
    // Show loading spinner while checking authentication
    return (
      <Loading width="48px" height="48px" className="mx-auto my-20" />
    );
  }

  // Check if user is authenticated
  const isAuthenticated = !!(user && token);
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;